/**
 * @flow
 * @author: Pavan
 */

import React, { Component } from 'react'
import ReactModal from 'react-modal'
import Colors from '../../themes/Colors'

import CloseModalIcon from '../../components/Icons/CloseModalIcon'

import { CloseIconWrapper } from './styledComponents'

type Props = {
  children: React.ChildrenArray<any>
}

ReactModal.defaultStyles.overlay.backgroundColor = Colors.black80

class BaseModalContainer extends Component<Props> {
  state = {
    modalIsOpen: false
  }

  static defaultProps = {
    hideCloseIcon: false
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true
    })
    document.body.style.overflowY = 'hidden'
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false
    })
    document.body.style.overflowY = 'scroll'
  }

  componentWillMount() {
    ReactModal.setAppElement('body')
  }

  render() {
    const { children, hideCloseIcon, ...other } = this.props
    const { modalIsOpen } = this.state
    return (
      <ReactModal closeTimeoutMS={150} isOpen={modalIsOpen} {...other}>
        {hideCloseIcon ? null : (
          <CloseIconWrapper onClick={this.closeModal}>
            <CloseModalIcon />
          </CloseIconWrapper>
        )}
        {children}
      </ReactModal>
    )
  }
}

export default BaseModalContainer



// WEBPACK FOOTER //
// ./src/commons/BaseModalContainer/index.js